export default {
  'tasks.title': 'Tareas',
  'tasks.filter.type': 'Tipo',
  'tasks.filter.processGroup': 'Grupo Procesos',
  'tasks.filter.type.task': 'Tarea',
  'tasks.filter.type.completeInformation': 'Completar Información',
  'tasks.filter.type.approval': 'Aprobación',
  'tasks.filter.type.executeTask': 'Ejecutar tarea',
  'tasks.filter.type.digitalSignature': 'Firma Digital',
  'tasks.filter.applicantUser': 'Solicitante',
  'tasks.filter.process': 'Proceso',
  'tasks.filter.importance': 'Importancia',
  'tasks.filter.overdue': 'Fecha de Vencimiento',
  'tasks.filter.planned': 'Fecha Planificada',
  'tasks.filter.reminder': 'Fecha de Recordatorio',

  'tasks.filter.type.none': 'Ninguna',
  'tasks.filter.type.low': 'Baja',
  'tasks.filter.type.medium': 'Media',
  'tasks.filter.type.high': 'Alta',
  'tasks.filter.type.urgent': 'Urgente',
  'tasks.filter.type.critical': 'Crítica',

  'tasks.importance.type0': 'Ninguna',
  'tasks.importance.type1': 'Baja',
  'tasks.importance.type2': 'Media',
  'tasks.importance.type3': 'Alta',
  'tasks.importance.type4': 'Urgente',
  'tasks.importance.type5': 'Crítica',

  'tasks.description.none': 'Sin prioridad',
  'tasks.description.low': 'Indica prioridad baja',
  'tasks.description.medium': 'Importancia media. No es urgente pero requiere atención.',
  'tasks.description.high': 'Alta prioridad, debe resolverse pronto.',
  'tasks.description.urgent': 'Requiere acción inmediata. El tiempo es un factor.',
  'tasks.description.critical': 'Situación de alto riesgo, requiere acción inmediata.',

  'tasks.text.overdueDateTime': 'Fecha de Vencimiento',
  'tasks.text.plannedDateTime': 'Fecha Planificada',
  'tasks.text.reminderDateTime': 'Fecha de Recordatorio',

  'tasks.list.created': 'La lista "{name}" ha sido creada correctamente',
  'tasks.list.updated': 'La lista "{name}" ha sido modificada correctamente',
  'tasks.list.removed': 'La lista "{name}" ha sido eliminada correctamente',
  'tasks.task.created': 'La tarea "{name}" ha sido creada correctamente',
  'tasks.task.updated': 'La tarea "{name}" ha sido modificada correctamente',
  'tasks.task.removed': 'La tarea "{name}" ha sido eliminada correctamente',
  'tasks.task.toMayDay': 'La tarea "{name}" ha sido asignada a Mi Día correctamente',

  'task.status.complete': 'Completar información',
  'task.status.approved': 'Aprobación',
  'task.status.execution': 'Ejecutar tarea',
  'task.status.signature': 'Firma digital',
  'task.detail.applicant': 'Solicitante',
  'task.detail.comment': 'Agregar Comentario',
  'task.detail.observation': 'Ingrese la observación',
  'task.detail.overdue': 'Vencimiento',
  'tasks.detail.notes': 'Notas',

  'tasks.empty.title': 'No tienes ninguna tarea asignada',
  'tasks.empty.subtitle': 'Seleccionar alguna tarea sugerida o crea alguna',
  'tasks.move.title': 'Mover Tarea',

  'tasks.text.listName': 'Nombre de la Lista',
  'tasks.text.createList': 'Crear Lista',
  'tasks.text.editList': 'Editar Lista',
  'tasks.text.customList': 'Listas Personalizadas',
  'tasks.text.taskTypes': 'Tipo de Tareas',
  'tasks.text.title': 'Título',
  'tasks.text.favorite': 'Favorito',
  'tasks.text.newTask': 'Adicionar Nueva Tarea',
  'tasks.text.assignTo': 'Asignar a',

  'tasks.type.task': 'Tarea',
  'tasks.type.tasks': 'Tareas',
  'tasks.type.my-day': 'Mi Día',
  'tasks.type.favorites': 'Favoritos',
  'tasks.type.planned': 'Planeado',
  'tasks.type.overdue': 'Vencidas',
  'tasks.type.completed': 'Completadas',
  'tasks.type.custom': 'Personalizado',

  'tasks.type.basic': 'Básica',
  'tasks.type.filter-by-process': 'Filtrada por Procesos',
  'tasks.type.filter-by-task-importances': 'Filtrada por Importancias',
  'tasks.type.link-custom-list': 'Anclar Lista Personalizada',
  'tasks.type.advanced-filter': 'Filtro Avanzado',
  'tasks.type.filter-by-task-type': 'Filtrada por Tipo',

  'tasks.status.pending': 'Pendiente',
  'tasks.status.in-progress': 'In Progress',
  'tasks.status.blocked': 'Bloqueado',
  'tasks.status.on-hold': 'En espera',
  'tasks.status.completed': 'Completada',
  'tasks.status.canceled': 'Cancelada',
  'tasks.status.failed': 'Fallidas',

  'tasks.status.type1': 'Pendiente',
  'tasks.status.type2': 'In Progress',
  'tasks.status.type3': 'Bloqueado',
  'tasks.status.type4': 'En espera',
  'tasks.status.type5': 'Completada',
  'tasks.status.type6': 'Cancelada',
  'tasks.status.type7': 'Fallidas',
};
